import { appConfig } from '../../../../../../../config/customization';
import Device from '../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 150,
    padding: 10
  },
  contactInfo: {
    background: appConfig.colors.contactItemColor,
    borderRadius: appConfig.complaints.squaredContactItems ? 0 : 4,
    padding: '6px 15px',
    outline: 0,
    marginTop: 10,
    [Device.desktop_tablet]: {
      maxWidth: 300
    }
  },
  image: {
    height: 100
  },
  link: {
    textDecoration: 'none'
  },
  mobileText: {
    [Device.tablet_mobile]: {
      padding: 0
    },
    [Device.mobile]: {
      padding: 0
    }
  },
  button: {
    padding: 0,
    height: 'auto',
    textAlign: 'center'
  }
};
